module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('p', {
    staticClass: "copy-right"
  }, [_vm._v("Copyright(C)2012 Wonderland TairaGroup. Allright Reserved.")])]), _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo-footer.png")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7d4bf94!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/app-footer.pug
// module id = 921
// module chunks = 1